const ContentStatuses = [
    {
        id: 0,
        title: "در انتظار تایید",
        icon: <i className="fa-regular fa-hourglass-clock status active" title="در انتظار تایید"></i>
    },
    {
        id: 1,
        title: "تایید شده",
        icon: <i className="fa-solid fa-check status active" title="تایید شده"></i>
    },
    {
        id: 2,
        title: "رد شده",
        icon: <i className="fa-solid fa-xmark status deactive" title="رد شده"></i>
    },
    {
        id: 3,
        title: "حذف شده",
        icon: <i className="fa-regular fa-trash status deactive" title="حذف شده"></i>
    },
    {
        id: 4,
        title: "پیش نویس",
        icon: <i className="fa-regular fa-hourglass-clock status active" title="پیش نویس"></i>
    },
];

export default ContentStatuses;